import { styled } from '@mui/system';
import { IconButton } from '@mui/material';
import InputField from '#component/form/input';

export const CustomFieldValue = styled(InputField)(() => ({
  width: 'calc(100% - 46px)'
}));

export const DeleteButton = styled(IconButton)(() => ({
  maxHeight: 30
}));
